/* eslint-disable no-cond-assign */

import ordinal from 'ordinal';

import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import { ComparisonItemDAO } from '../ProposalItemDAO';
import { DataPoints } from '../DataPoints';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';
import DonutData from '@/types/donut-data';

/**
 * @class CountryAllocationDAO Data Access Object
 */
export default class IndustryHoldingsDAO extends ComparisonItemBasedProposalDAO {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new IndustryHoldingsDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return ['DEFAULT'];
  }

  protected build(): void {
    let filterCount: number = 10;
    let start: number = 1;

    // test for options
    const daoConfig: ProposalNS.IndustryHoldingsConfig = this.proposalElement.DAO as ProposalNS.IndustryHoldingsConfig;
    if (daoConfig.filterTopXDAOOptions !== undefined) {
      filterCount = daoConfig.filterTopXDAOOptions.count;

      if (daoConfig.filterTopXDAOOptions.start) {
        start = daoConfig.filterTopXDAOOptions.start;
      }
    }

    for (let i = start; i < start + filterCount; i++) {
      const fieldName = this.formatMessage(`Common.Ordinal.${ordinal(i)}`);
      this.addFieldName(fieldName, ProposalStyleClassNames.ProposalTableContent);
    }

    let itemDAO = null;
    while ((itemDAO = this.nextItem()) !== null) {
      const cas = DataPoints.getTopNSectorAllocations(itemDAO.item, filterCount);

      for (let i = start; i < start + filterCount; i++) {
        const ca = cas[i - 1];

        if (ca !== undefined) {
          this.addItemField(itemDAO, this.getMessage(ca.name), ca.weight);
        } else {
          this.addItemField(itemDAO, '', {});
        }
      }
    }
  }

  getDonutData(index: number = 0): DonutData | null {
    const out: DonutData | null = super.getDonutData(index);

    if (out && this.colorsDict) {
      out.colorsDict = this.colorsDict;
    }
    return out;
  }

  // private methods

  private addItemField(itemDAO: ComparisonItemDAO, name: string, value: any): number {
    const field: ProposalFieldDAO = new ProposalFieldDAO(name, value, ProposalStyleClassNames.ProposalTableContent);
    this.addFieldDAO(itemDAO, field);
    return value;
  }
}
